export default __webpack_public_path__ + "static/media/single-project-page-01-img15.c2f919e4.png";